/**
 * DigHero — the one "Dig the Archive" entry (Discover tab for players; /creators for creators
 * and collectors). A card with an inline band search and quick filters. Not a single link
 * (it contains a form); the title row links to /dig.
 *
 * Dig.jsx reads ?q= (search, runs on load), ?source=etree|netlabels and ?filter=founder.
 */

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/archive.css';
import './DigHero.css';

export default function DigHero() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const submit = (e) => {
    e.preventDefault();
    const query = q.trim().slice(0, 100);
    navigate(query ? `/dig?q=${encodeURIComponent(query)}&source=etree` : '/dig');
  };
  return (
    <section className="dig-hero" aria-label="Dig the Archive">
      <Link to="/dig" className="dig-hero-head">
        <span className="dig-hero-icon" aria-hidden="true">📼</span>
        <span>
          <span className="dig-hero-eyebrow">The Archive</span>
          <span className="dig-hero-title">Dig the Archive</span>
        </span>
      </Link>
      <p className="dig-hero-sub">1,600+ bands that let fans tape their shows. Find one before anyone else.</p>
      <form className="ax-search dig-hero-search" onSubmit={submit} role="search">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search a band…"
          aria-label="Search the Live Music Archive"
          maxLength={100}
          enterKeyHint="search"
        />
        <button type="submit" className="ax-btn ax-btn--sm ax-btn--primary">Dig</button>
      </form>
      <div className="ax-chips dig-hero-chips">
        <Link className="ax-chip dig-hero-chip" to="/dig?filter=founder&source=etree">★ Founder&#39;s Picks</Link>
        <Link className="ax-chip dig-hero-chip" to="/dig?source=etree">Live Music</Link>
        <Link className="ax-chip dig-hero-chip" to="/dig?source=netlabels">Netlabels</Link>
      </div>
    </section>
  );
}
